export interface ContactUsMessageModel {
    title?: string
    email: string
    phone: string
    company: string
    message: string
    extraData: ContactUsMessageExtraDataModel
}

export type ContactUsMessageExtraDataModel =
    | EnterprisePerformanceOptionModel
    | ChangeParamsContact
    | AIModelsContact
    | TrialExpiredContact

export enum ContactUsMessageType {
    EnterprisePerformanceOption = "EnterprisePerformanceOption",
    ChangeParams = "ChangeParams",
    AIModels = "AIModels",
    TrialExpired = "TrialExpired",
    AITrainings = "AITraining"
}

interface EnterprisePerformanceOptionModel {
    type: ContactUsMessageType.EnterprisePerformanceOption
    appID: string
    ownerID: string
}

interface ChangeParamsContact {
    type: ContactUsMessageType.ChangeParams
    appID: string
    oldParams: any
    newParams: any
    projectName: string
    templateName: string
}

interface AIModelsContact {
    type: ContactUsMessageType.AIModels | ContactUsMessageType.AITrainings
    appID: string
}

interface TrialExpiredContact {
    type: ContactUsMessageType.TrialExpired
    ownerID: string
    appID: string
}
